import React from 'react';
import Lottie from 'react-lottie';
import styled from 'styled-components';
import animationData from 'assets/animations/loading.json';

type LoadingProps = {
  height?: number;
  width?: number;
};

const Loading: React.FC<LoadingProps> = ({ height, width }) => {
  return (
    <LoadingBase>
      <LoadingAnimation height={height} width={width} />
    </LoadingBase>
  );
};

export default Loading;

const LoadingAnimation: React.FC<LoadingProps> = ({ width = 24, height = 24 }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return <Lottie options={defaultOptions} width={width} height={height} />;
};

const LoadingBase = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
